import { combineReducers } from 'redux';

import errors from './errors';

import {
  ACTION_ADD_POSTBACK_SETTINGS,
} from '../actionTypes';


const data = (state = null, action) => {
  switch (action.type) {
    case ACTION_ADD_POSTBACK_SETTINGS:
      return action.payload.postbackSettings;

    default:
      return state;
  }
};

export default combineReducers({
  data,
  errors,
});
